import { useRef } from 'react';
import timeTracker from '../MainV2/icons/timeTracker.svg';
import { TimeTrackerModalRef } from '../TimeTrackerModal';
import { verifyPinCode } from 'widgets/RequestAdminLocalPW/Callback';

const ButtonTimeTracker = ({ title = 'Time Tracker' }: { title?: string }) => {
  const timeTrackerModalRef = useRef<TimeTrackerModalRef>(null);

  const callback = () => {
    timeTrackerModalRef.current?.open();
  };

  const handleOpen = () => {
    return verifyPinCode(() => callback());
  };

  return (
    <>
      <button className='btn' onClick={handleOpen} disabled={true}>
        <img src={timeTracker} alt='timeTracker' className='icon-action' />
        <span>{title}</span>
      </button>
    </>
  );
};

export default ButtonTimeTracker;
